import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { livePriceChange } from "./livePriceChange.thunk";

const INIT_STATE = {
  priceChange: -1,
  dashboardLivePrice: -1,
  loading: false,
  // Filter state for persistence
  filters: {
    selectedCategories: [],
    selectedBrands: [],
    selectedLocations: [],
    selectedCondition: 0,
    conditionValue: "",
    dateRange: {
      startValue: null,
      endValue: null,
    },
    selRowCount: 0,
    selPage: 0,
    search: "",
  },
};

export const fetchLivePriceChangeAsyncThunk = createAsyncThunk(
  "fetchLivePriceChange",
  livePriceChange
);

const livePriceChangeSlice = createSlice({
  name: "live price change",
  initialState: INIT_STATE,
  reducers: {
    setLivePriceChange: (state, action) => {
      if (action.payload.length == 0) {
        state.priceChange = -1;
      } else {
        state.priceChange = action.payload;
      }
    },
    setDashboardLivePriceChange: (state, action) => {
      state.dashboardLivePrice = action.payload;
    },
    // Filter state actions
    setSelectedCategories: (state, action) => {
      state.filters.selectedCategories = action.payload;
    },
    setSelectedBrands: (state, action) => {
      state.filters.selectedBrands = action.payload;
    },
    setSelectedLocations: (state, action) => {
      state.filters.selectedLocations = action.payload;
    },
    setSelectedCondition: (state, action) => {
      state.filters.selectedCondition = action.payload;
    },
    setConditionValue: (state, action) => {
      state.filters.conditionValue = action.payload;
    },
    setDateRange: (state, action) => {
      state.filters.dateRange = action.payload;
    },
    setSelRowCount: (state, action) => {
      state.filters.selRowCount = action.payload;
    },
    setSelPage: (state, action) => {
      state.filters.selPage = action.payload;
    },
    setSearch: (state, action) => {
      state.filters.search = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLivePriceChangeAsyncThunk.pending, (state) => {
        state.loading = true;
        return state;
      })
      .addCase(fetchLivePriceChangeAsyncThunk.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload?.data) {
          state.priceChange = action.payload.data;
        }
        return state;
      })
      .addCase(fetchLivePriceChangeAsyncThunk.rejected, (state) => {
        state.loading = false;
        return state;
      });
  },
});

export const { 
  setLivePriceChange, 
  setDashboardLivePriceChange,
  setSelectedCategories,
  setSelectedBrands,
  setSelectedLocations,
  setSelectedCondition,
  setConditionValue,
  setDateRange,
  setSelRowCount,
  setSelPage,
  setSearch,
} = livePriceChangeSlice.actions;
export default livePriceChangeSlice.reducer;
